module.exports = __webpack_public_path__ + "media/attack.5de51932.mp3";